import BoletimSection from "../BoletimSection/BoletimSection";
import ProgressBar from "../ProgressBar/ProgressBar";

function AtividadesExtra({ atividades }) {
	return (
		<BoletimSection
			title="Atividades Extracurriculares"
			icon="bulb"
		>
			<ProgressBar value={atividades.horas_cumpridas} maxValue={160} valueType="h" />
		</BoletimSection>
	);
}

export default AtividadesExtra;
